export default "#include <skinbase_vertex>\n#include <skinning_vertex>\n#include <skinnormal_vertex>"